import InputField, { InputFieldProps } from "./InputField";

const TextInputField = (props: InputFieldProps<string>) => {
  return (
    <InputField {...props}
      castToType={text => text}
      convertValueToText={text => text} />
  );
};

export default TextInputField;